export const environment = {
    production: true,
    url: "https://api-omc.policystreet.app",
    crmUrl: "https://api-crm.policystreet.app",
    source: "OmcUser",
};
